import { isDirectoryItemFavorite } from '../isDirectoryItemFavorite/isDirectoryItemFavorite';
import { isDirectoryItemMatchForText } from '../isDirectoryItemMatchForText/isDirectoryItemMatchForText';
import { isDirectoryMatchForTags } from '../isDirectoryMatchForTags/isDirectoryMatchForTags';
import memoizee from 'memoizee';

export const createDirectoryFilterFromFilterParams = memoizee(
    (filterParams) => {
        return function (item) {
            // Favorite check
            if (filterParams.favorites && !isDirectoryItemFavorite(item)) return false;

            // Check text
            if (filterParams.text && !isDirectoryItemMatchForText(filterParams.text, item)) return false;

            // Check tags
            if (filterParams.tags && !isDirectoryMatchForTags(filterParams.tags, item)) return false;

            return true;
        };
    },
    { maxAge: 300000 }
);
